export default __webpack_public_path__ + "static/media/cerealBar.5abb2be3.png";